import {
  DocumentData, FirestoreDataConverter, QueryDocumentSnapshot,
  SnapshotOptions, WithFieldValue,
} from '@angular/fire/firestore';
import { get, set } from 'lodash-es';
import { toDate } from '../utils';

export const DEFAULT_DATE_PROPERTIES = ['createdAt', 'updatedAt'];
export const DEFAULT_QUERY_LIMIT = 100;


/**
 * Default Firestore converter.
 * If `dateProperties` are not provided, the global defaults are used.
 */
export const defaultFirestoreConverter = <T>(
  dateProperties: string[] = DEFAULT_DATE_PROPERTIES
): FirestoreDataConverter<T> => ({
  toFirestore: (data: WithFieldValue<T>) => data as DocumentData,
  fromFirestore: (snapshot: QueryDocumentSnapshot, options: SnapshotOptions) => {
    const data = snapshot.data(options)!;
    dateProperties.forEach((property) => setPropertyDate(data, property));
    return data as T;
  }
});

export const setPropertyDate = (data, key) => {
  const value = get(data, key, null);
  if (value) {
    set(data, key, toDate(value));
  }
};
